import { useContext } from 'react';

import { ContextFiles } from '@widgets/Files/model/context';
import { TFileId } from '@widgets/Files/model/types/fileId.type';

import { useAppSelector } from '../../../../../store';
import { filesSelector } from '../../../../../store/slices/filesSlice/filesSlice';
// export const useDropdown = (fileId: TFileId) => {
export const useDropdown = () => {
    const { onChangeModalMode, onChangeCurrentFile } = useContext(ContextFiles);

    // const { originalUrl, name } = useAppSelector((state) =>
    //     filesSelector.selectById(state, fileId)
    // );

    return { onChangeModalMode, onChangeCurrentFile };
    // return { onChangeModalMode, onChangeCurrentFile, originalUrl, name };
};
